/**
 * Live password-requirements checklist — ports the Flutter sign-up /
 * reset-password "Password Requirements" box. Each rule shows a met/unmet
 * state from `getPasswordRequirements`. Token-driven; no raw hex.
 */
import { Check, X } from 'lucide-react'
import { getPasswordRequirements } from './password-rules'

export function PasswordChecklist({ password }: { password: string }) {
  const requirements = getPasswordRequirements(password)
  return (
    <div
      style={{
        padding: 'var(--s-3)',
        borderRadius: 'var(--r-sm)',
        background: 'var(--bg-sunk)',
        border: '1px solid var(--border)',
      }}
    >
      <span className="kicker" style={{ display: 'block', marginBottom: 'var(--s-2)' }}>
        Password requirements
      </span>
      <ul style={{ listStyle: 'none', margin: 0, padding: 0, display: 'flex', flexDirection: 'column', gap: 4 }}>
        {requirements.map((req) => (
          <li
            key={req.text}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 'var(--s-2)',
              fontSize: 'var(--fs-12)',
              color: req.isMet ? 'var(--ok-700)' : 'var(--text-mute)',
            }}
          >
            {req.isMet ? (
              <Check size={14} strokeWidth={2.25} color="var(--ok-500)" aria-hidden="true" />
            ) : (
              <X size={14} strokeWidth={2.25} color="var(--text-faint)" aria-hidden="true" />
            )}
            <span>{req.text}</span>
          </li>
        ))}
      </ul>
    </div>
  )
}
